import { useEffect, useState } from "react";

const useCurrentGeoLocation = () => {
  const [geoLocation, setGeoLocation] = useState({ latitude: null, longitude: null });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Geolocation is not supported by your browser");
      setIsLoading(false);
      return;
    }

    const timeoutId = setTimeout(() => {
      setError("Geolocation request timed out.");
      setIsLoading(false);
    }, 10000); // Custom timeout of 10 seconds

    navigator.geolocation.getCurrentPosition(
      (position) => {
        clearTimeout(timeoutId); // Clear timeout on success
        setGeoLocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
        setIsLoading(false);
      },
      (error) => {
        clearTimeout(timeoutId); // Clear timeout on error
        switch (error.code) {
          case error.PERMISSION_DENIED:
            setError("User denied the request for Geolocation.");
            break;
          case error.POSITION_UNAVAILABLE:
            setError("Location information is unavailable.");
            break;
          case error.TIMEOUT:
            setError("The request to get user location timed out.");
            break;
          default:
            setError("An unknown error occurred.");
        }
        setIsLoading(false);
      },
      { enableHighAccuracy: true }
    );

    return () => clearTimeout(timeoutId); // Cleanup timeout if component unmounts
  }, []);

  return { isLoading, geoLocation, error };
};

export default useCurrentGeoLocation;
